import { render, staticRenderFns } from "./IconReceiptRefundOutline.vue?vue&type=template&id=e8866e6c"
import script from "./IconReceiptRefundOutline.vue?vue&type=script&lang=js"
export * from "./IconReceiptRefundOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports